import { Button } from '@mui/material';
import { Interval } from 'date-fns';
import { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EditIcon } from '../../../assets/icons';
import { Device, MarketLocation } from '../../../generated/graphql';
import { ForecastAssistant } from './ForecastAssistant';

export interface ForecastAssistantButtonProps {
  disabled?: boolean;
  marketLocation: MarketLocation;
  device: Device;
  interval: Interval;
  label?: TemplateStringsArray;
}

export function ForecastAssistantButton({
  disabled,
  marketLocation,
  device,
  interval,
  label = 'FORECAST_ASSISTANT_BUTTON_LABEL' as unknown as TemplateStringsArray,
}: Readonly<ForecastAssistantButtonProps>): ReactElement<ForecastAssistantButtonProps> {
  const [t] = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        className="text-xs sm:text-sm"
        sx={{ borderColor: (theme: { palette: { primary: { main: string } } }) => theme.palette.primary.main }}
        color="primary"
        disabled={disabled}
        onClick={(event) => {
          setIsOpen(true);
          event.stopPropagation();
        }}
        data-testid="ForecastAssistantButton"
      >
        <EditIcon className="min-w-5" />
        <span className="ml-1 hidden sm:inline">{t(label)}</span>
      </Button>
      <ForecastAssistant
        marketLocation={marketLocation}
        device={device}
        open={isOpen}
        interval={interval}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
}
